import { FadeIn } from "@/components/FadeIn";
import { Check } from "lucide-react";

const standardIncluded = [
  "Trauerrede-Entwurf in 3 Längen (Kurz · Mittel · Ausführlich, bis 1.000 Wörter)",
  "Persönlich aus Ihren Antworten formuliert — in Sie- oder Du-Form",
  "Bis zu 3 Tonalitäts-Varianten inklusive",
  "Sofort verfügbar — als Text, PDF und per E-Mail",
  "Diskret. Keine Speicherung sensibler Daten.",
];

const premiumIncluded = [
  "Alles aus dem Standard-Paket",
  "Zusätzlich: Umfangreiche Rede bis 2.000 Wörter (ca. 9–14 Minuten Sprechzeit)",
  "Für ausführliche Würdigungen mit mehreren biografischen Stationen",
];

export default function Pricing({ onCta, loading, loadingPackage }) {
  return (
    <section id="pricing" className="py-24 md:py-36">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <FadeIn>
          <p className="label-eyebrow mb-6 text-center">Preis</p>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-charcoal text-center leading-[1.1]">
            Zwei klare Wege. Ein klares Versprechen.
          </h2>
        </FadeIn>

        <div className="mt-16 grid md:grid-cols-2 gap-6">
          <FadeIn delay={0.1}>
            <div data-testid="pricing-card-standard" className="bg-paper rounded-3xl p-8 md:p-10 shadow-card h-full flex flex-col">
              <div className="pb-6 border-b border-umber/10">
                <p className="font-display tracking-[0.3em] text-[11px] text-umber mb-3">Standard</p>
                <h3 className="font-serif text-2xl text-charcoal">Ein persönlicher Entwurf</h3>
                <div className="mt-4 flex items-baseline gap-2">
                  <span className="font-serif text-5xl text-charcoal" data-testid="pricing-amount-standard">29 €</span>
                  <span className="font-sans text-sm text-ink">einmalig · inkl. MwSt.</span>
                </div>
              </div>

              <ul className="mt-6 space-y-3 flex-1">
                {standardIncluded.map((item, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <Check className="w-4 h-4 text-umber flex-shrink-0 mt-1" strokeWidth={1.4} />
                    <span className="font-serif text-base text-charcoal leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>

              <button
                onClick={() => onCta("oratio_draft")}
                disabled={loading}
                data-testid="pricing-cta-standard"
                className="btn-primary mt-8 w-full disabled:opacity-60"
              >
                {loading && loadingPackage === "oratio_draft" ? "Wird vorbereitet…" : "Standard wählen"}
              </button>
            </div>
          </FadeIn>

          <FadeIn delay={0.2}>
            <div data-testid="pricing-card-premium" className="bg-paper rounded-3xl p-8 md:p-10 shadow-card h-full flex flex-col relative">
              <div className="absolute -top-3 right-8 bg-charcoal text-cream font-display tracking-[0.25em] text-[10px] uppercase px-4 py-1.5 rounded-full">
                Umfangreich
              </div>
              <div className="pb-6 border-b border-umber/10">
                <p className="font-display tracking-[0.3em] text-[11px] text-umber mb-3">Premium</p>
                <h3 className="font-serif text-2xl text-charcoal">Eine ausführliche Würdigung</h3>
                <div className="mt-4 flex items-baseline gap-2">
                  <span className="font-serif text-5xl text-charcoal" data-testid="pricing-amount-premium">49 €</span>
                  <span className="font-sans text-sm text-ink">einmalig · inkl. MwSt.</span>
                </div>
              </div>

              <ul className="mt-6 space-y-3 flex-1">
                {premiumIncluded.map((item, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <Check className="w-4 h-4 text-umber flex-shrink-0 mt-1" strokeWidth={1.4} />
                    <span className="font-serif text-base text-charcoal leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>

              <button
                onClick={() => onCta("oratio_premium")}
                disabled={loading}
                data-testid="pricing-cta-premium"
                className="btn-primary mt-8 w-full disabled:opacity-60"
              >
                {loading && loadingPackage === "oratio_premium" ? "Wird vorbereitet…" : "Umfangreich wählen"}
              </button>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3}>
          <p className="font-sans text-xs text-ink/70 text-center mt-8">
            Sichere Zahlung über Stripe. Nach der Zahlung gelangen Sie direkt zum Generator.
          </p>
        </FadeIn>
      </div>
    </section>
  );
}
